import axios from "axios";
import { getAuthHeader } from "./authService";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/bookings/`;

export type BookingHubRow = {
  id: number;
  type: "event" | "magazine";
  status: string | null;
  payment: string | null;
  booth: number | null;
  company: { id: number; name: string } | null;
  event: { id: number; title: string } | null;
  publication: string | null;
  issue: string | null;
  detail: string;
  sales_rep: { id: number; username: string; email: string } | null;
  createdAt: string;
  detail_path: string;
  company_path?: string | null;
  archived_at?: string | null;
};

export type BookingHubParams = {
  type?: "all" | "event" | "magazine";
  status?: string;
  company_id?: string;
  event_id?: string;
  publication_id?: string;
  issue_id?: string;
  sales_rep_id?: string;
  q?: string;
  archived?: string;
};

export const getBookingsHub = async (params?: BookingHubParams): Promise<BookingHubRow[]> => {
  const headers = getAuthHeader();
  try {
    const response = await axios.get(`${API_URL}`, { headers, params });
    return response.data || [];
  } catch (error: any) {
    console.log(error.message);
    return [];
  }
};
